import React, { Component } from 'react'

import PropTypes from 'prop-types'

export default class RadioButton extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string,
    value: PropTypes.string,
    checked: PropTypes.bool
  }

  render() {
    const { name, id, onChange, checked, value, children } = this.props

    return (
      <div className="radio_button_wrapper">
        <input type="radio" name={name} id={id} value={value} checked={checked} onChange={e => onChange(e)} />
        <label htmlFor={id}>
          <span />
          {children}
        </label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/RadioButton.jsx